var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25007 2H15.7499C15.7499 2.03671 15.7527 2.07386 15.7583 2.11126L18.7416 22H5.25836L8.24167 2.11126C8.24728 2.07386 8.25002 2.03671 8.25007 2ZM12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V7C11.25 7.41421 11.5858 7.75 12 7.75C12.4142 7.75 12.75 7.41421 12.75 7V4ZM12 9.25C11.5858 9.25 11.25 9.58579 11.25 10V13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13V10C12.75 9.58579 12.4142 9.25 12 9.25ZM12.75 16C12.75 15.5858 12.4142 15.25 12 15.25C11.5858 15.25 11.25 15.5858 11.25 16V19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2417 21.8887C20.2432 21.8987 20.2445 21.9086 20.2456 21.9186C21.1743 21.6446 21.8075 20.7167 21.6555 19.7033L19.2555 3.70332C19.1086 2.72428 18.2676 2 17.2776 2H17.2584L20.2417 21.8887Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74161 2H6.72237C5.73238 2 4.89135 2.72428 4.7445 3.70332L2.3445 19.7033C2.19249 20.7167 2.82564 21.6446 3.75442 21.9186C3.75551 21.9086 3.7568 21.8987 3.75829 21.8887L6.74161 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.f3e1a5c45197c115adb3e3ca7cec5af5.svg";
export { ForwardRef as ReactComponent };